/* eslint-disable import/prefer-default-export */

import { map } from 'lodash';

import { casingFormat, formatName } from 'common/utils';

export const transformListOrderLineItems = ({ listOrderLineItems }) => ({
  count: listOrderLineItems.count,
  orderLineItems: map(
    listOrderLineItems.results,
    ({
      patient,
      partner,
      lineItem,
      orderId,
      orderStatus,
      partnerAccountId,
      source,
      isReshipment,
      state,
      createdAt,
      waitingOnFill,
      totalInOrder,
    }) => {
      const { patientDemographics, mpi } = patient;
      const patientName = `${casingFormat(
        formatName(patientDemographics.lastName)
      )}, ${casingFormat(formatName(patientDemographics.firstName))}`;
      const {
        itemName: rawItemName,
        needsByDate,
        shipByDate,
        requestedDate,
        lineItemId,
        fillType,
        fulfillingPharmacyId,
      } = lineItem;
      const itemName = rawItemName ? casingFormat(rawItemName) : rawItemName;
      const { shippingOption, inBatchShipmentQueue, isBusinessAddress } = lineItem;
      const { isOtc, quantity, lastUpdated, tags, ndc, duplicateOfRxNumber } = lineItem;
      const { packSizeValue, packSizeUnit, formAlias, strength: rawStrength } = lineItem;
      const strength = rawStrength === 'NA' ? undefined : rawStrength;

      return {
        orderId,
        mpi,
        patientName,
        partnerName: partner.partnerName,
        requestedDate,
        itemName,
        lineItemId,
        orderStatus,
        needsByDate,
        shipByDate,
        partnerAccountId,
        fillType,
        fulfillingPharmacyId,
        inBatchShipmentQueue,
        isBusinessAddress,
        shippingOption,
        quantity,
        source,
        isReshipment,
        isOtc,
        ndc,
        packSizeValue,
        packSizeUnit,
        formAlias,
        strength,
        drugName: itemName,
        requestNeedsByDate: needsByDate,
        lastUpdated,
        state,
        createdAt,
        waitingOnFill,
        totalInOrder,
        tags,
        duplicateOfRxNumber,
      };
    }
  ),
});
